import { registerPlugin } from '@capacitor/core';

import type { FeelNativePlugin } from './definitions';

const FeelNative = registerPlugin<FeelNativePlugin>('FeelNative', {
  web: () => import('./web').then((m) => new m.FeelNativeWeb()),
});

export * from './definitions';
export { FeelNative };
